import { SearchFilterValue } from "../../models/SearchConfiguration";

export const emptyFilterValue = "";
export const emptyFilterListItemValue = "__vsa_empty_filter_value__";

export const normalizeFilterValue = (
  fieldUniqueName: string,
  value: string
) =>
  fieldUniqueName.toLowerCase() === "filetype" ? value.toLowerCase() : value;

export const getUniqueFilterValues = (
  fieldUniqueName: string,
  values: SearchFilterValue[]
): SearchFilterValue[] => {
  if (fieldUniqueName.toLowerCase() !== "filetype") {
    return cloneFilters(values);
  }

  const uniqueValues = new Map<string, SearchFilterValue>();
  values.forEach((filterValue) => {
    const normalizedValue = normalizeFilterValue(
      fieldUniqueName,
      filterValue.value
    );
    if (!uniqueValues.has(normalizedValue)) {
      uniqueValues.set(normalizedValue, {
        value: normalizedValue,
        displayValue: normalizedValue,
      });
    }
  });

  return Array.from(uniqueValues.values());
};

export const getFilterValuesForSelection = (
  fieldUniqueName: string,
  values: SearchFilterValue[],
  selectedValues: string[]
): SearchFilterValue[] => {
  const normalizedSelectedValues = new Set(
    selectedValues.map((value) =>
      normalizeFilterValue(fieldUniqueName, value)
    )
  );

  return values.filter((filterValue) =>
    normalizedSelectedValues.has(
      normalizeFilterValue(fieldUniqueName, filterValue.value)
    )
  );
};

export const cloneFilters = (values: SearchFilterValue[]): SearchFilterValue[] => {
  return [...values];
}

export const toFilterListItemValue = (value: string) =>
  value === emptyFilterValue ? emptyFilterListItemValue : value;

export const fromFilterListItemValue = (value: string) =>
  value === emptyFilterListItemValue ? emptyFilterValue : value;


